module.exports = __webpack_public_path__ + "static/media/fruit-icon-avocado.163d80be.jpg";